import styled, { css } from 'styled-components';

/**
 * O $ é uma convenção comum no styled-components para indicar que a prop não deve ir para o DOM.
 */
export interface CollapsibleProps {
  $collapsed: boolean;
}

interface AbaProps extends CollapsibleProps {
  $isActive: boolean;
}

export const SidebarContainer = styled.div<CollapsibleProps>`
  background-color: ${({ theme }) => theme.colors.sidebar.fundo};
  height: 100vh;
  display: grid;
  grid-template-rows: 17% 73% 10%;
  position: relative;

  width: ${({ $collapsed }) => ($collapsed ? '72px' : '260px')};
  max-width: ${({ $collapsed }) => ($collapsed ? '72px' : '260px')};

  transition: width 900ms cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: width;

  box-sizing: border-box;

  container-type: inline-size;
`;

export const SidebarParteMenor = styled.div<CollapsibleProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  padding: ${({ $collapsed }) => ($collapsed ? '12px 0' : '1vh')};
  transition: width 900ms cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: width;

  width: ${({ $collapsed }) => ($collapsed ? '72px' : '260px')};
  max-width: ${({ $collapsed }) => ($collapsed ? '72px' : '260px')};

  color: white;
  background-color: ${({ theme }) => theme.colors.sidebar.fundoLogo};
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  img {
    height: ${({ $collapsed }) => ($collapsed ? '32px' : '35%')};
    transition: height 900ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .sidebar__titulo,
  .sidebar__subtitulo,
  .sidebar__versao {
    opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
    transform: ${({ $collapsed }) =>
      $collapsed ? 'translateX(-8px)' : 'translateX(0)'};
    transition:
      opacity 160ms ease,
      transform 160ms ease;

    pointer-events: ${({ $collapsed }) => ($collapsed ? 'none' : 'auto')};
    will-change: opacity, transform;
  }

  .sidebar__titulo {
    font-size: 2.2vh;
  }

  .sidebar__subtitulo {
    font-size: 0.9rem;
  }

  .sidebar__versao {
    font-size: 1.25vh;
  }
`;

export const SidebarParteMaior = styled.div<CollapsibleProps>`
  padding: ${({ $collapsed }) => ($collapsed ? '24px 8px' : '2vh 3vh')};
  transition: padding 240ms cubic-bezier(0.4, 0, 0.2, 1);

  background-color: ${({ theme }) => theme.colors.sidebar.fundo};

  width: ${({ $collapsed }) => ($collapsed ? '72px' : '260px')};
  max-width: ${({ $collapsed }) => ($collapsed ? '72px' : '260px')};
  transition: width 900ms cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: width;

  @media screen and (max-width: 768px) {
    padding: 2%;
  }
`;

export const Aba = styled.div<AbaProps>`
  padding: 12px;
  border-radius: 12px;
  transition:
    background-color 0.3s ease-in-out,
    border-left 0.3s ease-in-out;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed }) =>
    $collapsed ? 'center' : 'flex-start'};
  gap: ${({ $collapsed }) => ($collapsed ? '0' : '12px')};
  font: 500 14px/19px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverSidebar};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: white;
      background-color: ${({ theme }) => theme.colors.hoverSidebar};
    `}
`;

export const AbaLabel = styled.span<CollapsibleProps>`
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'inline')};
`;

export const MenuIcon = styled.span<CollapsibleProps>`
  display: ${({ $collapsed }) => ($collapsed ? 'inline-flex' : 'none')};
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: white;
  line-height: 1;
  pointer-events: none;
`;

export const ListaAbas = styled.div<CollapsibleProps>`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.8vh;
  color: white;
  width: 100%;
  align-items: ${({ $collapsed }) => ($collapsed ? 'center' : 'stretch')};
`;

export const AreaUsuario = styled.div<CollapsibleProps>`
  font-size: 3vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $collapsed }) =>
    $collapsed ? 'center' : 'flex-start'};
  padding: ${({ $collapsed }) =>
    $collapsed ? '20px 0 16px 0' : '20px 20px 10px 20px'};
  color: white;
  border-radius: 20px 20px 0px 0px;
  background-color: ${({ theme }) => theme.colors.sidebar.fundoAreaUsuario};

  transition: width 1000ms cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: width;

  img {
    height: 50%;
    border-radius: 50%;
    border: solid 0.5px white;
  }

  img:hover {
    cursor: pointer;
  }
`;

export const ContainerUser = styled.div<CollapsibleProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed }) =>
    $collapsed ? 'center' : 'flex-start'};
  width: 100%;
  cursor: pointer;
  transition: width 900ms cubic-bezier(0.25, 0.8, 0.25, 1);
  will-change: width;
`;

export const CircleIcon = styled.div<CollapsibleProps>`
  width: ${({ $collapsed }) => ($collapsed ? '44px' : '50px')};
  height: ${({ $collapsed }) => ($collapsed ? '44px' : '50px')};
  border-radius: 50%;
  background-color: #4babf3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -14px;
  margin-right: ${({ $collapsed }) => ($collapsed ? '0' : '15px')};

  .material-icons {
    color: #fff;
    font-size: 1.5rem;
  }
`;

// export const UserInfo = styled.div<CollapsibleProps>`
//   display: ${({ $collapsed }) => ($collapsed ? 'none' : 'flex')};
//   flex-direction: column;
// `;

export const UserInfo = styled.div<CollapsibleProps>`
  display: none;
  flex-direction: column;

  @container (min-width: 220px) {
    display: flex;
  }
`;

export const UserName = styled.span`
  font:
    600 16px 'Segoe UI',
    sans-serif;
  line-height: 1.5;
`;

export const UserLotacao = styled.p<CollapsibleProps>`
  display: ${({ $collapsed }) => ($collapsed ? 'none' : 'block')};
  font:
    300 16px 'Segoe UI',
    sans-serif;
`;

export const ToggleButton = styled.button<CollapsibleProps>`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  color: white;
  padding: 0;
  line-height: 0;
  transition: transform 0.3s ease;
  z-index: 2;

  &:hover {
    transform: scale(1.05);
  }

  .material-icons {
    font-size: 1.4rem;
  }
`;
